import { EffectFade, Navigation, Thumbs } from 'swiper'
import { Swiper, type SwiperProps } from 'swiper/react'
import { NavigationButton } from '../../NavigationButton/NavigationButton'
import type { MainSliderProps } from './MainSlider.types'

export const MainSlider = ({
  slider,
  onSwiper,
  thumbSlider,
  hasArrows,
  onSlideChange,
  children,
  loop = true,
}: MainSliderProps): JSX.Element => {
  const sliderSettings: SwiperProps = {
    modules: [Navigation, Thumbs, EffectFade],
    loop,
    onSwiper,
    thumbs: {
      swiper: thumbSlider,
      multipleActiveThumbs: true,
    },
    effect: 'slide',
    breakpoints: {
      768: {
        allowTouchMove: false,
      },
    },
    onSlideChange,
  }

  return (
    <Swiper {...sliderSettings}>
      {hasArrows ? (
        <NavigationButton
          buttonType="prev"
          onClick={() => {
            slider?.slidePrev()
          }}
        />
      ) : null}

      {children}
      {hasArrows ? (
        <NavigationButton
          buttonType="next"
          onClick={() => {
            slider?.slideNext()
          }}
        />
      ) : null}
    </Swiper>
  )
}
